import { useState } from "react";
import { Link } from "react-router-dom";
import { Btn, Eyebrow, Empty } from "@/components/brand";
import { useSite, useSeo } from "@/components/site";
import { ResultCard, ReviewCard, FinalCta } from "@/pages/Home";

const FILTERS = [["ALL", ""], ["SCORE GROWTH", "Score Growth"], ["DELETIONS", "Deletions"], ["INQUIRY SWEEPS", "Inquiry Sweeps"]];

export default function Results() {
  useSeo("Results", "Real clients. Real deletions. Real fast. Verified results from Se7en Capital Group clients.");
  const { data: site } = useSite();
  const [f, setF] = useState("");
  const st = site?.stats || {};
  const stats = [["Clients helped", st.clients], ["Items removed", st.items], ["Average increase", st.increase], ["Rating", st.rating]].filter(([, v]) => v);
  const results = (site?.results || []).filter((r) => !f || (r.category || "").toLowerCase() === f.toLowerCase());
  return (
    <>
      <section className="bg-ink text-white py-20 lg:py-28" data-testid="results-hero">
        <div className="max-w-7xl mx-auto px-5 lg:px-8">
          <Eyebrow light>Client outcomes</Eyebrow>
          <h1 className="f-display text-4xl sm:text-5xl lg:text-6xl mt-4 max-w-3xl">Real clients. Real deletions. Real fast.</h1>
          {stats.length > 0 && (
            <dl className="grid grid-cols-2 lg:grid-cols-4 gap-6 mt-14 border-t border-white/15 pt-10">
              {stats.map(([l, v]) => <div key={l}><dt className="eyebrow text-white/60">{l}</dt><dd className="f-display text-4xl sm:text-5xl mt-2 gold-foil-dark font-semibold">{v}</dd></div>)}
            </dl>
          )}
        </div>
      </section>
      <section className="bg-white py-16 lg:py-24">
        <div className="max-w-7xl mx-auto px-5 lg:px-8">
          <div className="flex gap-2 overflow-x-auto no-scrollbar" role="tablist">
            {FILTERS.map(([l, v]) => (
              <button key={l} role="tab" aria-selected={f === v} onClick={() => setF(v)} data-testid={`results-filter-${l.toLowerCase().replace(/\s/g, "-")}`}
                className={`btn btn-sm ${f === v ? "btn-black" : "btn-outline"}`}>{l}</button>
            ))}
          </div>
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5 mt-10">
            {results.map((r, i) => <ResultCard key={i} r={r} />)}
          </div>
          {!results.length && <Empty testid="results-empty" title="Verified results are being added." text="Book a consultation and I'll walk you through what's possible for your report." />}
        </div>
      </section>
      {site?.reviews?.length > 0 && (
        <section id="reviews" className="bg-cream py-16 lg:py-24 scroll-mt-20">
          <div className="max-w-7xl mx-auto px-5 lg:px-8">
            <Eyebrow n="05">5-star reviews</Eyebrow>
            <h2 className="f-display text-4xl sm:text-5xl mt-4">In their words.</h2>
            <div className="grid md:grid-cols-3 gap-5 mt-10">{site.reviews.map((r, i) => <ReviewCard key={i} r={r} />)}</div>
          </div>
        </section>
      )}
      <section className="bg-white py-14 text-center">
        <h2 className="f-display text-3xl sm:text-4xl">You're next — start now.</h2>
        <Btn as={Link} to="/consultation" arrow className="mt-6" data-testid="results-start-btn">Book Free Consultation</Btn>
      </section>
      <FinalCta />
    </>
  );
}
